const state  = {
    original_index : 0, // 原创达人榜的index
    cate_list:[]  , // 原创达人榜分页
    activity_list:{},// 活动详情
}
export default state


// WEBPACK FOOTER //
// ./src/store/state.js